export default function DS_Regression_R_Squared() {
  return <div>DS_Regression_R_Squared Component</div>;
}
